module.exports = __webpack_public_path__ + "img/blue_ic_profile.4e98a266.svg";